import {
  filter,
  lastValueFrom,
  map,
  Subject,
  Subscription,
  takeUntil,
} from "rxjs";
import { NavigationService } from "./../../../../core/services/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NodeService } from "./../../../../core/services/node.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Node, NodeAction } from "src/app/core/models/node";
import { interval } from "rxjs";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { Deployment } from "src/app/core/models/deployment";
import { MatSlider } from "@angular/material/slider";
import { AddNodeComponent } from "../../modals/add-node/add-node.component";
import { JobsService } from "src/app/core/services/jobs.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Job } from "src/app/core/models/job";
import { DepConfirmationComponent } from "src/app/modules/deployment/modals/dep-confirmation/dep-confirmation.component";
import { ScaleConfirmationComponent } from "../../modals/scale-confirmation/scale-confirmation.component";
import { NodeactionConfirmComponent } from "../../modals/nodeaction-confirm/nodeaction-confirm.component";
import { SyncConfigService } from "src/app/core/services/sync-config.service";
import {
  CloudTypes,
  Entities,
  HpcVMStates,
  NodeTypes,
  PeroformNodeAction,
  ResourceAvailability,
} from "src/app/core/models/globals";
import {
  UserRoleNames,
  UserRolesInt,
  Users,
} from "../../../../core/models/users";
import { UserService } from "../../../../core/services/user.service";
import { ConfigEntityService } from "../../../../core/services/config-entity.service";
import { ConfigParameter } from "../../../../core/models/config-entities";
import { StorageService } from "src/app/core/services/storage.service";
import { TerminalLoginDialogComponent } from "src/app/core/header/dialogs/terminal-login-dialog/terminal-login-dialog.component";
import { TerminalComponent } from "src/app/core/header/dialogs/terminal/terminal.component";
import { HeaderService } from "src/app/core/services/header.service";
import { DynamicWorkstationComponent } from "../../modals/dynamic-workstation/dynamic-workstation.component";
import { UpdateNodeComponent } from "../../modals/update-node/update-node.component";
import { NodeNetwork } from "../../../../core/models/nodeNetwork";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { AttachNodeComponent } from "../../modals/attach-node/attach-node.component";
import { ChartsService } from "../../../../core/services/charts.service";
import { NodeReportsComponent } from "../../modals/node-reports/node-reports.component";
import { SessionService } from "../../../../core/services/session.service";
import { EditColoumsComponent } from "../../modals/edit-coloums/edit-coloums.component";
import { UserSetting } from "../../../../core/models/userSetting";
import { EnvironmentService } from "src/app/core/services/environment.service";
import { AttachVGPUComponent } from "../../modals/attach-v-gpu/attach-v-gpu.component";
import { RemoveSessionComponent } from "../../modals/remove-session/remove-session.component";
import { ResizeNodeComponent } from "../../modals/resize-node/resize-node.component";
import { AddNodeFromTemplateComponent } from "../../modals/add-node-from-template/add-node-from-template.component";
import { SyncNodesComponent } from "../../modals/sync-nodes/sync-nodes.component";

@Component({
  selector: "app-node-list",
  templateUrl: "./node-list.component.html",
  styleUrls: ["./node-list.component.scss"],
})
export class NodeListComponent implements OnInit, OnDestroy {
  columnInfo: {
    columnsOfComponents: string[];
    coloumToShow: string[];
  };
  nodeListColumnToShow: string[] = [];
  configParameters: ConfigParameter[];
  obj: object;
  toShow;
  user: string;
  currentEntity;
  depName =
    this.route.snapshot.params["deploymentName"] ||
    this.route.parent.snapshot.params["deploymentName"];
  tempVmName; //temporary
  p = 1; // current pagination index
  nodes: Node[];
  multiSelectedNodes: Node[] = [];
  dataReloadSubscription: Subscription;
  scaleValue: number;
  scaleMax: number;
  scaleStepSize: number;
  temporaryScaleValue: number;
  newScaleMax: number;
  walletBalnce: number;
  deploymentDetails: Deployment;
  cloudType: string =
    this.route.snapshot.params["cloudType"] ||
    this.route.parent.snapshot.params["cloudType"];
  reloadNotificationData: Subscription;
  actionValue: string = "0";
  loggedUserData: Users;
  nodeDataRequestSub: Subscription;
  nodeDetailsSub: Subscription;
  nodeName: string;
  node: Node;
  autoScaleStatus: any;
  headAndComputeNodeActive: boolean = false;
  loggedInUser: string = this.authenticationService.currentUserValue.username;
  autoscaleValue: number = 3;
  @ViewChild("slider") public slider: MatSlider;
  selectedNode: Node;
  multiSelectIndex = [];
  tooltipHtml: string;
  filterDeployment: string =
    this.route.snapshot.params["deploymentName"] ||
    this.route.parent.snapshot.params["deploymentName"];
  public nodeTypes = Object.values(NodeTypes);
  filterNodetypes: string = "All";
  filterAvailability: string = "All";
  vmStates = Object.values(HpcVMStates);
  filterState: string = "All";
  filterPlatform: string = "All";
  filterCores: string = "All";
  deploymentFilterApplied: boolean = false;
  universalSub: Subscription; // subscription used for getting applications, users, active, etc data
  activeSort: string = "none"; // for checking if any sort is active while, used when auto refreshing data
  selectedIndex: number;
  avlDeploymentsForFilter: string[] = [];
  nodesSearchText: string = "";
  filteredNodes: Node[];
  message: string = "";
  nodeNetwork: NodeNetwork = {
    name: "",
    privateIp: "fetching...",
    publicIp: "fetching...",
    ipType: "fetching...",
    dns: "fetching...",
    macAddress: "fetching...",
    gatewayName: "fetching...",
    NewMachineName: "",
  };
  tableName: string = "nodeList";
  availabilityList: string[] = [];
  isCloudKVM = this.cloudType == CloudTypes.KVM;
  wsNamesObj: Node[];
  autoRescaleFlag: boolean = false;
  available: boolean = true;
  toShowStart: boolean = true;
  toShowStop: boolean = true;
  toShowRestart: boolean = true;
  toShowConnect: boolean = true;
  showBilling: boolean;
  autoScaleActive: boolean = true;
  autoScaleActive2: boolean = false;
  isUserGlobalAdmin: boolean =
    this.authenticationService.getRole() == UserRoleNames.GlobalAdmin;
  isNotJobOperator: boolean = true;
  isNotDeploymentAdmin: boolean = true;
  isSelectAll: boolean = false;
  filtersApplied: boolean = false;
  cpuSort: boolean = false; // sort
  ramSort: boolean = false; // sort
  gpuSort: boolean = false; // sort
  gpuMemorySort: boolean = false; // sort
  forcefully: boolean = false;
  isVdiDeployment: boolean = false;
  isWakeOnLanEnabled: boolean = false;
  isMonitor: boolean =
    this.authenticationService.currentUserValue.role == UserRoleNames.Reader
      ? true
      : false;
  isOnPremiseVdi: boolean = false;
  showAttachSelected = true;
  toShowFilter: boolean = false;
  vmName: string = "";
  entriesNumber: number = 18;
  nodeNumberToShow: number = 18;
  allNodes: any = [];
  detailsViewOpen: boolean = false;
  config = {
    itemsPerPage: 18,
    currentPage: 1,
  };
  availabilitySort: boolean = false;
  coresSort: boolean = false;
  destroy$ = new Subject<void>();

  constructor(
    public userServices: UserService,
    public nodeService: NodeService,
    private route: ActivatedRoute,
    private router: Router,
    public navService: NavigationService,
    protected authenticationService: AuthenticationService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private depService: DeploymentService,
    private jobService: JobsService,
    public spinner: NgxSpinnerService,
    private configEntityService: ConfigEntityService,
    public syncConfig: SyncConfigService,
    private sharedService: NavigationService,
    private storageService: StorageService,
    public _headerService: HeaderService,
    protected chartService: ChartsService,
    protected sessionService: SessionService,
    private _deploymentService: DeploymentService,
    private _env: EnvironmentService
  ) { }

  ngOnInit(): void {
    this.navService.sendChildData(this.depName);
    this.columnInfo = {
      columnsOfComponents: [],
      coloumToShow: [],
    };
    this.vmStates = this.vmStates.filter(
      (e) => e != HpcVMStates.STATE_CODE_STOPING
    );
    this.columnInfo.columnsOfComponents = [
      "Availability",
      "State",
      "Allocated",
      "GPU Mem %",
      "GPU %",
      "Sessions",
      "SchedulerState",
      "Node Group",
      "Network (Mb/sec)",
    ];
    //this.createLocalStorage();
    this.spinner.show("nodeList");
    if (
      this.authenticationService.currentUserValue.role ===
      UserRoleNames.JobOperator
    ) {
      this.isNotJobOperator = false;
    }
    if (
      this.authenticationService.currentUserValue.role ===
      UserRoleNames.DeploymentAdmin
    ) {
      this.isNotDeploymentAdmin = false;
    }
    this._deploymentService.checkIsVdi(this.depName).subscribe({
      next: (data) => {
        this.isVdiDeployment = Boolean(data);
      },
    });

    this._deploymentService.checkIsOnpremiseVdi(this.depName).subscribe({
      next: (data) => {
        this.isOnPremiseVdi = Boolean(data);
      },
    });
    this.nodeService.getUseVncFileTagValue(this.depName).subscribe({
      next: (data: any) => {
        this.isWakeOnLanEnabled = data.isWakeOnLanEnabled;
      },
    });
    if (this.cloudType == CloudTypes.OnPremise) {
      this.toShowStart = false;
      this.toShowStop = false;
      this.toShowRestart = false;
    }
    this.navService.sendParentData(Entities.Nodes);
    this.loadNodeData();
    this.getScaleData();
    this.startDataReloadSub();
    this.navService.breadcrumbEntity.subscribe((x) => {
      this.currentEntity = x;
    });
    if (this.currentEntity != Entities.Nodes) {
      this.navService.sendLeftPanelIndex(1);
    } else {
      this.navService.sendLeftPanelIndex(0);
    }
    this.checkUserWallet();
    if (this.cloudType != CloudTypes.OnPremise) {
      this.loadDeploymentSettings();
    }
    this.getColumnSetting();
    this.nodeService.sendNodeAction
      .pipe(
        takeUntil(this.destroy$),
        filter((x) => x != null)
      )
      .subscribe((action) => {
        this.nodeAction(action.action, action.node);
      });
  }

  ngOnDestroy() {
    this.dataReloadSubscription?.unsubscribe();
    this.nodeDataRequestSub?.unsubscribe();
    this.universalSub?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.resetSortFilter();
    this.nodeService.updateNodeAction(null);
  }

  formatLabel(value: number): string {
    return `${value}`;
  }

  loadDeploymentSettings() {
    this.configEntityService
      .getDeploymentConfigs(this.depName, this.cloudType)
      .subscribe((data) => {
        this.configParameters = <ConfigParameter[]>(
          JSON.parse(JSON.stringify(data))
        );
        if (this.configParameters.length > 1) {
          let autoRescaleParam: ConfigParameter = this.configParameters.filter(
            (x) => x.parameterName.toLowerCase() == "autorescaleflag"
          )[0];
          if (autoRescaleParam) {
            if (autoRescaleParam.parameterValue.toLowerCase() == "false") {
              this.autoRescaleFlag = false;
            } else {
              this.autoRescaleFlag = true;
            }
          }
        }
      });
  }

  loadNodeData() {
    if (this.filtersApplied != true) {
      this.nodeDataRequestSub = this.nodeService
        .getNodesForDeployment(this.depName)
        .pipe(
          map((nodes: any) => {
            if (nodes) {
              this.entriesNumber = nodes.length;
              this.allNodes = nodes;
              this.vmName = nodes[0].vmName;
              nodes?.forEach((n) => {
                n.actionsAvl = this.returnActionsAvailableForNodes(n, false);
              });
              return nodes;
            }
          })
        )
        .subscribe((data) => {
          if (data) {
            this.nodes = JSON.parse(JSON.stringify(data));
            if (this.nodes) {
              this.available = true;
              this.availabilityList = [
                ...new Set([...this.nodes.map((e) => e.availability)]),
              ].sort();
              if (!this.selectedNode) {
                this.selectedNode = this.nodes[0];
                this.autoScaleActive = this.nodes[0].autoScale;
                this.redirectTo(this.nodes[0], 0);
              }
              this.selectedIndex = this.nodes.findIndex(
                (node) =>
                  node.vmName == this.selectedNode.vmName &&
                  node.depName == this.selectedNode.depName
              );
              this.nodeService.updateSelectedNode(
                this.nodes[this.selectedIndex]
              );
            } else {
              this.available = false;
            }
            this.spinner.hide("nodeList");
          } else {
            this.available = false;
            this.spinner.hide("nodeList");
          }
        });
    }
  }

  showAllEntriesMethod() {
    if (this.entriesNumber > 0) {
      this.nodeNumberToShow = this.entriesNumber;
    }
  }

  paginationEntries(event) {
    this.entriesNumber = event.target.value;
  }

  getUSer() {
    this.user = this.authenticationService.currentUserValue.username;
  }

  getScaleData() {
    if (this.depName == "All") return;
    this.depService.getDeployment(this.depName).subscribe({
      next: (data) => {
        this.deploymentDetails = <Deployment>JSON.parse(JSON.stringify(data));
        this.scaleStepSize = this.deploymentDetails.coresPerNode;
        this.scaleMax =
          Number(this.deploymentDetails.coresPerNode) *
          Number(this.deploymentDetails.numOfComputeNodes);

        this.autoRescaleFlag = this.deploymentDetails.autoRescaleFlag || false;

        if (this.deploymentDetails.autoRescaleFlag === true) {
          if (this.scaleMax > this.walletBalnce) {
            this.autoScaleActive2 = false;
          } else if (this.scaleMax < this.walletBalnce) {
            this.autoScaleActive2 = true;
          }
        }

        this.scaleValue = this.deploymentDetails.runningCores;
        this.temporaryScaleValue = this.scaleValue;
        this.showBilling = this.deploymentDetails.showBillingData;
        this.nodeService.showBilling(this.showBilling);
      },
      error: (error) => { },
    });
  }

  checkUserWallet() {
    this.userServices
      .getUserDetails(this.authenticationService.currentUserValue.username)
      .subscribe((data) => {
        this.loggedUserData = <Users>JSON.parse(JSON.stringify(data));
        this.walletBalnce = this.loggedUserData.walletAmount;
      });
  }

  redirectTo(node: Node, index: number) {
    this.selectedNode = node;
    this.selectedIndex = this.nodes.findIndex((nd) => nd.vmName == node.vmName);
    this.nodeService.activeNode = node;
    this.nodeService.updateSelectedNode(node);
    // this.router.navigate([node.vmName, "Details"], { relativeTo: this.route });
  }

  hideJobDetails() {
    this.detailsViewOpen = false;
  }

  checkSelectedCheckboxes(event, nodeName) {
    let filteredNodes = this.applyFilter();
    if (event.target.checked) {
      if (!this.multiSelectIndex?.includes(nodeName)) {
        this.multiSelectIndex.push(nodeName);
        if (this.multiSelectIndex?.length == this.nodes.length) {
          this.isSelectAll = true;
        }
      }
      if (this.multiSelectIndex) {
        let node = this.nodes?.filter((obj) => obj.vmName == nodeName)![0];
        this.multiSelectedNodes?.push(node);
        if (this.multiSelectedNodes) {
          this.showAttachSelected = this.multiSelectedNodes?.every(
            (d) => d.connectorType == this.multiSelectedNodes![0].connectorType
          );
        }
      }
    } else {
      let idx = this.multiSelectIndex?.indexOf(nodeName);
      this.multiSelectIndex.splice(idx, 1);
      if (
        this.multiSelectIndex.length == 0 ||
        this.multiSelectIndex.length != this.nodes.length
      ) {
        this.isSelectAll = false;
      }
      if (this.multiSelectIndex) {
        this.multiSelectedNodes = this.multiSelectedNodes?.filter(
          (obj) => obj.vmName != nodeName
        );
        if (this.multiSelectedNodes) {
          this.showAttachSelected = this.multiSelectedNodes?.every(
            (d) => d.connectorType == this.multiSelectedNodes![0].connectorType
          );
        }
      }
    }
  }

  // node specific start/stop/restart/connect
  async nodeAction(action: NodeAction, node: Node) {
    if (
      node.nodeType == NodeTypes.TxtHeadNode ||
      node.nodeType == NodeTypes.TxtHead_Workstore ||
      node.nodeType == NodeTypes.TxtHead_Compute_Workstore
    ) {
      this.headAndComputeNodeActive = this.checkStateOfNodes();
    } else {
      this.headAndComputeNodeActive = false;
    }

    switch (action.name) {
      case PeroformNodeAction.TxtStart:
        if (
          node.state == HpcVMStates.STATE_CODE_STOPING_CANCEL_WAIT ||
          node.state == HpcVMStates.STATE_CODE_STOPING
        ) {
          this.forcefully = true;
          this.message =
            "Node is in " +
            node.state +
            "state. Do you still want to " +
            action.name +
            " the Node, Forcefully!?";
          this.performAction(action, node);
          return;
        } else {
          this.forcefully = false;
          this.message = "Do you want to " + action.name + " the Node?";
          this.performAction(action, node);
          return;
        }
        break;

      case PeroformNodeAction.TxtStop:
        if (
          node.state === HpcVMStates.STATE_CODE_STARTING ||
          node.state === HpcVMStates.STATE_CODE_PRESTARTED
        ) {
          this.forcefully = true;
          this.message =
            "Node is in " +
            node.state +
            "state. Do you still want to " +
            action.name +
            " the node, Forcefully?";
          this.performAction(action, node);
          return;
        }
        if (
          node.state == HpcVMStates.STATE_CODE_STARTED ||
          node.state == HpcVMStates.STATE_CODE_ACTIVE_OFFLINE ||
          node.state == HpcVMStates.STATE_CODE_STOPPED_DEALLOC ||
          node.state == HpcVMStates.STATE_CODE_STOPING ||
          node.state == HpcVMStates.STATE_CODE_STOPING_CANCEL_WAIT
        ) {
          this.forcefully = false;
          this.message = "Do you want to " + action.name + " the Node?";
          this.performAction(action, node);
          return;
        }
        this.snackBar.open("Node is not in active state.", "Ok", {
          duration: 5000,
        });
        break;

      case PeroformNodeAction.TxtConnect:
        if (!this.isVdiDeployment) {
          if (node.state === HpcVMStates.STATE_CODE_STOPPED_DEALLOC) {
            this.snackBar.open("Node is not in active state.", "Ok", {
              duration: 5000,
            });
            return;
          } else {
            this.message = "Do you want to " + action.name + " the Node?";
            this.performAction(action, node);
          }
        } else {
          if (
            node.state == HpcVMStates.STATE_CODE_STOPPED_DEALLOC &&
            this.isWakeOnLanEnabled
          ) {
            this.message = "Do you want to " + action.name + " the Node?";
            this.performAction(action, node);
          } else if (
            node.state == HpcVMStates.STATE_CODE_STOPPED_DEALLOC &&
            !this.isWakeOnLanEnabled
          ) {
            this.snackBar.open("Node is not in active state.", "Ok", {
              duration: 5000,
            });
            return;
          } else {
            this.message = "Do you want to " + action.name + " the Node?";
            this.performAction(action, node);
          }
        }
        break;

      case PeroformNodeAction.TxtRestart:
        if (
          node.state != HpcVMStates.STATE_CODE_STARTED &&
          node.state != HpcVMStates.STATE_CODE_UPDATING
        ) {
          this.snackBar.open("Node is not in active state.", "Ok", {
            duration: 5000,
          });
          return;
        } else {
          this.message =
            "Do you want to " + action.name + " the Node forcefully?";
          //this.performAction(action, node)
          if (!this.isVdiDeployment) {
            this.jobService.hasActiveJobs(this.depName).subscribe({
              next: (data: any) => {
                let countObj = JSON.parse(JSON.stringify(data));
                if (countObj.count > 0) {
                  this.dialog
                    .open(ConfirmDialogComponent, {
                      autoFocus: false,
                      disableClose: false,
                      width: "25%",
                      data: {
                        titleMessage: "Jobs Active",
                        bodyMessage: `Jobs Are Currently Active on the Node, Do you still want to restart the node forcefully?.`,
                        cancelText: "Cancel",
                        submitText: "Proceed",
                      },
                    })
                    .afterClosed()
                    .subscribe((res) => {
                      if (res) {
                        this.forcefully = true;
                        this.performAction(action, node);
                      } else {
                        return;
                      }
                    });
                } else {
                  this.forcefully = false;
                  this.performAction(action, node);
                }
              },
              error: (err) => {
                this.snackBar.open(err.error?.actionMessage, "Ok", {
                  duration: 5000,
                });
                return;
              },
            });
          } else {
            this.performAction(action, node);
          }
        }
        break;

      case PeroformNodeAction.TxtAttach:
        break;

      case PeroformNodeAction.TxtDetach:
        this.dialog
          .open(ConfirmDialogComponent, {
            autoFocus: false,
            disableClose: false,
            width: "25%",
            data: {
              titleMessage: "Detach Workstation",
              bodyMessage: `Do you want to detach following workstations ${node.vmName}.`,
              cancelText: "Cancel",
              submitText: "Proceed",
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.snackBar.open("Action is in progress.", "Ok", {
                duration: 5000,
              });
              this.nodeService
                .triggerNodeAction(
                  node.vmName,
                  node.depName,
                  action.value.toString(),
                  node.vmPlatform,
                  this.forcefully,
                  false,
                  node.nodeType,
                  false
                )
                .subscribe({
                  next: (data: any) => {
                    this.snackBar.open(data.body?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                    this.loadAllNodesList();
                    this.refreshComponent();
                  },
                  error: (err) => {
                    this.snackBar.open(err.error?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                  },
                });
            }
          });
        break;

      case PeroformNodeAction.TxtRemove:
        this.removeSession(node);
        break;

      case PeroformNodeAction.TxtReports:
        this.dialog.open(NodeReportsComponent, {
          data: { depName: node.depName, wsName: node.vmName },
        });
        break;

      case PeroformNodeAction.TxtTerminal:
        this.openTerminal(node);
        break;

      case PeroformNodeAction.TxtEdit:
        this.getNetworkInfo();
        this.dialog
          .open(UpdateNodeComponent, {
            autoFocus: false,
            disableClose: true,
            width: "25%",
            data: {
              nodeInfo: this.selectedNode,
              nodeNetwork: this.nodeNetwork,
              depName: !this.selectedNode.depName
                ? this.selectedNode.allDeploymentsList
                : this.selectedNode.depName,
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) this.refreshComponent();
          });
        break;

      case PeroformNodeAction.TxtDelete:
        this.dialog
          .open(ConfirmDialogComponent, {
            autoFocus: false,
            disableClose: false,
            width: "25%",
            data: {
              titleMessage: "Delete Workstation",
              bodyMessage: `Do you want to delete workstation <span class="text-danger">${node.vmName}</span>?`,
              cancelText: "Cancel",
              submitText: "Proceed",
              skipMessage: node.cloudType == CloudTypes.KVM ? "Skip deletion from SyncHpcInfra" : "Skip Cloud Deletion",
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.snackBar.open("Action is in progress.", "Ok", {
                duration: 5000,
              });
              const skipCloud = res.skipCloudDeployment;
              this.nodeService
                .triggerNodeAction(
                  node.vmName,
                  node.depName,
                  action.value.toString(),
                  node.vmPlatform,
                  false,
                  false,
                  node.nodeType,
                  skipCloud
                )
                .subscribe({
                  next: (data: any) => {
                    this.snackBar.open(data.body?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                    this.loadAllNodesList();
                    this.refreshComponent();
                  },
                  error: (err) => {
                    this.snackBar.open(err.error?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                  },
                });
            }
          });
        break;

      case PeroformNodeAction.TxtAttachvGPU:
        this.dialog.open(AttachVGPUComponent, {
          autoFocus: false,
          disableClose: false,
          width: "30%",
          data: {
            hostNodeId: node.hostNodeId,
            depName: this.depName,
            activeNodeName: node.vmName,
            vmId: node.vmId,
            action: "attach",
            titleMessage: "Attach vGPU",
          },
        });
        break;

      case PeroformNodeAction.TxtDetachvGPU:
        this.dialog
          .open(ConfirmDialogComponent, {
            autoFocus: false,
            disableClose: false,
            width: "25%",
            data: {
              titleMessage: "Detach vGPU",
              bodyMessage: `Do you want to detach vGPU from following workstations ${node.vmName}?.`,
              cancelText: "Cancel",
              submitText: "Proceed",
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              if (!node.hostNodeId || node.hostNodeId == null) {
                this.snackBar.open(
                  `Can not perform action since no host found for ${node.vmName}.`,
                  "Ok",
                  { duration: 5000 }
                );
                return;
              }
              this.snackBar.open("Action is in progress.", "Ok", {
                duration: 5000,
              });
              this.nodeService
                .detachvGPU(
                  node.vmName,
                  node.hostNodeId,
                  node.depName,
                  node.vmId,
                  "dettach"
                )
                .subscribe({
                  next: (data: any) => {
                    this.snackBar.open(data?.successMessage, "Ok", {
                      duration: 5000,
                    });
                    this.refreshComponent();
                  },
                  error: (err) => {
                    this.snackBar.open(err?.error?.successMessage, "Ok", {
                      duration: 5000,
                    });
                  },
                });
            }
          });
        break;

      case PeroformNodeAction.TxtUnmapUser:
        this.forcefully = false;
        this.message =
          "Do you want to " + action.name + " from this workstation?";
        this.performAction(action, node);
        return;

      case PeroformNodeAction.TxtAttachChildNodes:
        const dialogRef = this.dialog.open(AttachNodeComponent, {
          width: "450px",
          disableClose: true,
          autoFocus: false,
          data: {
            depName: this.depName,
            cloudType: this.cloudType,
            wsAttached: this.nodes,
            connectorType: this.deploymentDetails.cloud,
            hostVmId: node.hostNodeId,
          },
        });
        dialogRef.afterClosed().subscribe((response) => {
          if (response) {
            this.loadNodeData();
            this.refreshComponent();
          }
        });
        break;

      case PeroformNodeAction.TxtResizeVm:
        let userRole = this._headerService.getUserRoleForDeployment(
          this.depName
        );
        if (userRole == 3) {
          this.snackBar.open(
            "You are not authorized to perform this action",
            "Ok",
            {
              duration: 5000,
            }
          );
          return;
        }
        const dialogAddRef = this.dialog.open(ResizeNodeComponent, {
          width: "450px",
          disableClose: true,
          autoFocus: false,
          data: {
            depName: this.depName,
            cloudType: this.cloudType,
            nodeName: node.vmName,
            nodeConfig: node?.instanceType,
            isResize: true,
            state: node.state,
          },
        });

        dialogAddRef.afterClosed().subscribe((response) => {
          if (response) {
            this.loadNodeData();
            this.refreshComponent();
          }
        });
        break;

      case PeroformNodeAction.TxtOpenConsole:
        this.message = "Do you want to open console ?";
        this.performAction(action, node);
        break;
    }
  }

  checkStateOfNodes() {
    let i = 1;
    for (i; i < this.nodes.length; i++) {
      if (this.nodes[i].state == HpcVMStates.STATE_CODE_STARTED) {
        return true;
      }
    }
    return false;
  }

  onSave(value) {
    const dialogRef = this.dialog.open(ScaleConfirmationComponent, {
      disableClose: true,
      width: "400px",
      data: {
        deployment: this.depName,
        title: "Scale Nodes",
        message: "Do you want to change number of CPU cores to " + value + "?",
      },
    });
    dialogRef.afterClosed().subscribe(async (res) => {
      if (res) {
        this.snackBar.open("Node Scale in progress.");
        this.scaleValue = value;
        this.nodeService.scaleUpDownNodes(this.depName, value).subscribe({
          next: (data) => {
            this.scaleValue = value;
            this.temporaryScaleValue = this.scaleValue;
            this.loadNodeData();
            this.snackBar.open(data.message, "Ok", { duration: 5000 });
            this.refreshComponent();
          },
          error: (err) => {
            this.snackBar.open(err.error.message, "Ok", { duration: 5000 });
            this.refreshComponent();
          },
        });
      } else {
        this.scaleValue = this.temporaryScaleValue;
      }
    });
  }

  onValueChange(event) {
    // this.scaleValue = event.value;
    this.onSave(event);
  }

  //start all / stop all nodes
  public async deploymentActions(value) {
    if (value == 1) {
      const dialogRef = this.dialog.open(DepConfirmationComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          title: "Start All Nodes ",
          message: "Do you want to start all nodes ?",
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe(async (res) => {
        if (res) {
          this.spinner.show("nodeList");
          await this.nodeService
            .startStopAllNodes(this.depName, "StartAllNodes")
            .subscribe({
              next: (data: any) => {
                this.spinner.hide("nodeList");
                this.snackBar.open(data.actionMessage, "Ok", {
                  duration: 3000,
                });
                this.loadNodeData();
              },
              error: (error: any) => {
                this.spinner.hide("nodeList");
                this.snackBar.open(error.error.actionMessage, "Ok", {
                  duration: 3000,
                });
              },
            });
        }
        this.actionValue = "0";
      });
    } else if (value == 2) {
      if (!this.checkIfAllNodesAreInactive()) {
        return false;
      }
      this.spinner.show("nodeList");
      // let isJobsActive = await this.checkIfJobIsActive();
      // if (isJobsActive) return;
      let criticalMessage = "Do you want to stop all nodes ?";

      this.jobService.hasActiveJobs(this.depName).subscribe({
        next: (data: any) => {
          let countObj = JSON.parse(JSON.stringify(data));
          if (countObj.count > 0) {
            criticalMessage =
              "Jobs are currently active on the node, do you still want to stop all nodes?.";
          }
        },
        error: (err) => {
          this.spinner.hide("nodeList");
        },
      });

      await new Promise((r) => setTimeout(r, 1000));

      this.spinner.hide("nodeList");
      const dialogRef = this.dialog.open(DepConfirmationComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          title: "Stop All Nodes",
          message: criticalMessage,
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.spinner.show("nodeList");
          this.nodeService
            .startStopAllNodes(this.depName, "StopAllNodes")
            .subscribe({
              next: (data: any) => {
                this.spinner.hide("nodeList");
                this.snackBar.open(data.actionMessage, "Ok", {
                  duration: 3000,
                });
                this.loadNodeData();
              },
              error: (error: any) => {
                this.spinner.hide("nodeList");
                this.snackBar.open(error.error.actionMessage, "Ok", {
                  duration: 3000,
                });
              },
            });
        }
        this.actionValue = "0";
      });
    } else if (value == 3 || value == 4) {
      let title: string, msg: string, autoScaleFlag: boolean, snackBar: string;

      if (value == 3) {
        title = "Enable AutoScale";
        msg = "Do you want to enable autoscale for current deployment ?";
        snackBar = "Enabled";
        autoScaleFlag = true;
      } else {
        title = "Disable AutoScale";
        msg = "Do you want to disable autoscale for current deployment ?";
        snackBar = "Disabled";
        autoScaleFlag = false;
      }

      const dialogRef = this.dialog.open(DepConfirmationComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          title: title,
          message: msg,
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.nodeService
            .enableDisableAutoScale(this.depName, autoScaleFlag)
            .subscribe(() => {
              this.snackBar.open(snackBar + " AutoScale", "Ok", {
                duration: 5000,
              });
              if (this.autoscaleValue == 3 && this.autoScaleActive == false) {
                this.autoscaleValue = 4;
                this.autoScaleActive = true;
              } else {
                this.autoscaleValue = 3;
                this.autoScaleActive = false;
              }
              this.loadNodeData();
            });
        }
        this.actionValue = "0";
      });
    } else if (value == 6) {
      if (this.multiSelectIndex.length == 0) {
        this.snackBar.open("Select node(s)  to perform action", "Ok", {
          duration: 5000,
        });
        this.refreshComponent();
        this.actionValue = "0";
        return;
      }
      const dialogRef = this.dialog.open(DepConfirmationComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          title: "Detach selected Nodes",
          message: "Do you want to detach the selected nodes ?",
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.wsNamesObj = this.nodes
            ?.filter((nd) => {
              return this.multiSelectIndex?.includes(nd.vmName);
            })
            .map((nd) => {
              return nd;
            });
          this.wsNamesObj?.forEach((e) => {
            this.nodeService
              .triggerNodeAction(
                e.vmName,
                e.depName,
                "6",
                e.vmPlatform,
                false,
                false,
                e.nodeType,
                false
              )
              .subscribe({
                next: (data: any) => {
                  this.snackBar.open(data.body?.actionMessage, "Ok", {
                    duration: 5000,
                  });
                  this.wsNamesObj = [];
                  this.loadNodeData();
                  this.refreshComponent();
                },
                error: (err) => {
                  this.wsNamesObj = [];
                  this.snackBar.open(err.error?.actionMessage, "Ok", {
                    duration: 5000,
                  });
                },
              });
          });
        }
        this.actionValue = "0";
      });
    }
  }

  openAddNodeDialog() {
    let userRole = this._headerService.getUserRoleForDeployment(this.depName);
    if (userRole == 3) {
      this.snackBar.open(
        "You are not authorized to perform this action",
        "Ok",
        {
          duration: 5000,
        }
      );
      return;
    }
    const dialogRef = this.dialog.open(AddNodeComponent, {
      width: "40vw",
      disableClose: true,
      autoFocus: false,
      data: {
        depName: this.depName,
        cloudType: this.cloudType,
        nodeList: this.nodes,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loadNodeData();
        this.refreshComponent();
      }
    });
  }

  openRemoveSessionDialog(nodeName) {
    const dialogRef = this.dialog.open(RemoveSessionComponent, {
      width: "800px",
      disableClose: true,
      autoFocus: false,
      data: {
        initiator: this.loggedInUser,
        vmName: nodeName,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loadNodeData();
        this.refreshComponent();
      }
    });
  }

  openAttachNodeDialog() {
    const dialogRef = this.dialog.open(AttachNodeComponent, {
      width: "450px",
      disableClose: true,
      autoFocus: false,
      data: {
        depName: this.depName,
        cloudType: this.cloudType,
        wsAttached: this.nodes,
        connectorType: this.deploymentDetails?.cloud,
        hostVmId: null,
      },
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loadNodeData();
        this.refreshComponent();
      }
    });
  }

  async checkIfJobIsActive(isScale?: boolean) {
    const res: any = await lastValueFrom(
      this.jobService.getJobPerUser(this.depName, "all", 500, true)
    );

    let jobs: Job[] = res;
    if (!jobs) return false;

    let count = jobs.filter(
      (job) => job.state === HpcVMStates.STATE_CODE_STARTED
    );
    this.actionValue = "0";
    if (count.length != 0) {
      let msg = "Nodes cannot be stopped. Some of jobs are in active state.";
      if (isScale) msg = "Cannot scale, some of jobs are in active state.";
      this.snackBar.open(msg, "Ok", {
        duration: 5000,
      });
      return true;
    }
    return false;
  }

  checkIfAllNodesAreInactive() {
    let filtered: Node[] = this.nodes.filter((node) =>
      node.state.includes("Inactive")
    );
    if (filtered.length === this.nodes.length) {
      this.snackBar.open("Nodes are already in inactive state", "Ok", {
        duration: 5000,
      });
      setTimeout(() => {
        this.actionValue = "0";
      }, 10);
      return false;
    }
    return true;
  }

  onOutletLoaded(component) {
    component.depName = this.depName;
    component.activeNodeName = this.selectedNode?.vmName;
  }

  public async openTerminal(node: Node) {
    this.spinner.show("nodeList");
    const headNodeIp: any = await lastValueFrom(
      this.storageService.getHeadNodeIp(node.depName ?? node.allDeploymentsList)
    );
    this.spinner.hide("nodeList");
    const loginDialog = this.dialog.open(TerminalLoginDialogComponent, {
      width: "25vw",
      autoFocus: false,
      disableClose: true,
      data: { depName: this.depName, headNodeIp: headNodeIp?.vmIp },
    });
    loginDialog.afterClosed().subscribe((data) => {
      if (data) {
        if (!headNodeIp || !headNodeIp.vmIp) {
          this.snackBar.open(
            "Error fetching node ip, cannot open terminal.",
            "Ok",
            { duration: 5000 }
          );
          return;
        }
        this.sharedService.closeOpenedDialogs();
        this.dialog.open(TerminalComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: "custom-terminal-container",
          hasBackdrop: false,
          id: "terminalDialog",
          data: {
            username: data.username,
            password: data.password,
            serverAddress: this._deploymentService.getUrlForUtilityService(
              this.depName,
              headNodeIp.vmIp,
              this._env.envVariables.UtilityAccessPort,
              4,
              this.deploymentDetails?.routeViaSynchpc
            ),
          },
        });
      }
    });
  }

  onSelectAllCheckBox(event) {
    let filteredNodes = this.applyFilter();
    if (event.target.checked) {
      filteredNodes?.forEach((node, i) => {
        if (!this.multiSelectIndex?.includes(node.vmName)) {
          this.multiSelectIndex.push(node.vmName);
        }
      });
      if (filteredNodes?.length == this.nodes.length) {
        this.isSelectAll = true;
      }
      return;
    } else {
      filteredNodes?.forEach((node, i) => {
        if (this.multiSelectIndex.includes(node.vmName)) {
          let index = this.multiSelectIndex.indexOf(node.vmName);
          if (index !== -1) {
            this.multiSelectIndex.splice(index, 1);
          }
        }
      });
      if (filteredNodes?.length == this.nodes.length) {
        this.isSelectAll = false;
      }
      return;
    }
  }

  goToSession() { }

  returnActionsAvailableForNodes(
    node: Node,
    fromAllNodes: boolean = false
  ): NodeAction[] {
    let actions: NodeAction[] = [
      {
        name: "Start",
        value: 1,
        title: "Start node",
        icon: "bi-caret-right",
        disabled: false,
      },
      {
        name: "Stop",
        value: 2,
        title: "Stop node",
        icon: "bi-stop",
        disabled: false,
      },
      {
        name: "Connect",
        value: 3,
        title: "Connect Node",
        icon: "bi-link",
        disabled: false,
      },
      {
        name: "Restart",
        value: 4,
        title: "Restart selected node",
        icon: "bi-bootstrap-reboot",
        disabled: false,
      },
      {
        name: "Attach",
        value: 5,
        title: "Attach workstation to deployment",
        icon: "bi-node-plus",
        disabled: true,
      },
      {
        name: "Detach",
        value: 6,
        title: "Detach workstation from deployment",
        icon: "bi-input-cursor",
        disabled: true,
      },
      {
        name: "Remove Session",
        value: 7,
        title: "Remove on-going sessions",
        icon: "bi-box-arrow-right",
        disabled: true,
      },
      {
        name: "Reports",
        value: 8,
        title: "View reports of node",
        icon: "bi-graph-up",
        disabled: true,
      },
      {
        name: "Terminal",
        value: 9,
        title: "Open terminal",
        icon: "bi-terminal",
        disabled: true,
      },
      {
        name: "Edit",
        value: 10,
        title: "Edit Workstation Details",
        icon: "bi bi-pencil-square",
        disabled: true,
      },
      {
        name: "Delete",
        value: 11,
        title: "Delete Node",
        icon: "bi bi-x-lg",
        disabled: true,
      },
      {
        name: "Attach vGPU",
        value: 12,
        title: "Attach vGPU",
        icon: "bi bi-cpu-fill",
        disabled: true,
      },
      {
        name: "Detach vGPU",
        value: 13,
        title: "Detach vGPU",
        icon: "bi bi-cpu",
        disabled: true,
      },
      {
        name: "Attach Childs",
        value: 14,
        title: "Attach Child Nodes of this Host.",
        icon: "bi bi-diagram-3",
        disabled: true,
      },
      {
        name: "Resize Node",
        value: 15,
        title: "Resize Node.",
        icon: "bi bi-arrows-angle-expand",
        disabled: true,
      },
      {
        name: "Console",
        value: 16,
        title: "Request a console.",
        icon: "bi bi-pc-display-horizontal",
        disabled: true,
      },
    ];

    if (node?.nodeType) {
      if (node.nodeType == NodeTypes.TxtSecondaryHeadNode) {
        actions.forEach(item => {
          item.disabled = true;
        });
        return actions;
      }
    }

    if (node.nodeType == NodeTypes.TxtSecondaryHeadNode) {
      return;
    }

    let currentUserRole =
      !this.depName || this.depName == "All"
        ? UserRolesInt.GlobalAdmin
        : this._headerService.getUserRoleForDeployment(this.depName);
    if (node.cloudType == CloudTypes.OnPremise) {
      let isxCATStr = this.configEntityService?.SyncHpcXMLParameters?.find(
        (param) => param.parameterName === "xCATSupport"
      )?.parameterValue;
      let isxCAT = isxCATStr === "true";
      if (!isxCAT) {
        actions.find((act) => act.value == 1).disabled = true;
        actions.find((act) => act.value == 2).disabled = true;
        actions.find((act) => act.value == 4).disabled = true;
      }
    }

    if (
      (node.nodeType.includes("Head") ||
        node.nodeType.includes("Workstation")) &&
      node.vmPlatform.toLowerCase() != "windows" &&
      node.cloudType != CloudTypes.KVM
    ) {
      actions.find((act) => act.value == 9).disabled = false;
    }

    switch (currentUserRole) {
      case UserRolesInt.GlobalAdmin:
        if (!node.isAllowedToConnect && !node.reserved)
          actions.find((act) => act.value == 3).disabled = true;
        if (node.nodeType == NodeTypes.TxtHwHost)
          actions.find((act) => act.value == 14).disabled = false;

        if (
          node.cloudType == CloudTypes.KVM &&
          (this.depName && this.depName.toLowerCase() != "all") &&
          (node.nodeType == NodeTypes.TxtWorkstation ||
            [
              NodeTypes.TxtWorkstation.valueOf()
            ].includes(node.nodeType))
        ) {
          actions.find((act) => act.value == 15).disabled = false;
          if (node.state == 'Active')
            actions.find((act) => act.value == 16).disabled = false;
        }

        if (
          node.nodeType == NodeTypes.TxtWorkstation &&
          node.cloudType == CloudTypes.KVM
        ) {
          if (node.state.includes('Inactive')) {
            actions.find((act) => act.value == 11).disabled = false;
            actions.find((act) => act.value == 12).disabled = false;
            actions.find((act) => act.value == 13).disabled = false;
          }
          else {
            actions.find((act) => act.value == 11).disabled = true;
            actions.find((act) => act.value == 12).disabled = true;
            actions.find((act) => act.value == 13).disabled = true;
          }
        }

        if (
          node.cloudType == CloudTypes.MicrosoftAzure &&
          (this.depName && this.depName.toLowerCase() != "all") &&
          (node.nodeType == NodeTypes.TxtWorkstation ||
            [
              NodeTypes.TxtWorkstation.valueOf(),
              NodeTypes.TxtHeadNode.valueOf(),
              NodeTypes.TxtHead_Compute_Workstore.valueOf(),
              NodeTypes.TxtHead_Workstore.valueOf(),
            ].includes(node.nodeType))
        ) {
          actions.find((act) => act.value == 15).disabled = false;
        }

        if (
          node.cloudType == CloudTypes.Google &&
          (this.depName && this.depName.toLowerCase() != "all") &&
          [
            HpcVMStates.STATE_CODE_STOPPED.valueOf(),
            HpcVMStates.STATE_CODE_STOPPED_DEALLOC.valueOf(),
          ].includes(node.state)
        ) {
          actions.find((act) => act.value == 15).disabled = false;
        }

        break;

      case UserRolesInt.DeploymentAdmin:
        if (!node.isAllowedToConnect)
          actions.find((act) => act.value == 3).disabled = true;
        if (node.nodeType == NodeTypes.TxtHwHost)
          actions.find((act) => act.value == 14).disabled = false;

        if (
          node.nodeType == NodeTypes.TxtWorkstation &&
          node.cloudType == CloudTypes.KVM
        ) {
          if (node.state.includes('Inactive')) {
            actions.find((act) => act.value == 11).disabled = false;
            actions.find((act) => act.value == 12).disabled = false;
            actions.find((act) => act.value == 13).disabled = false;
          }
          else {
            actions.find((act) => act.value == 11).disabled = true;
            actions.find((act) => act.value == 12).disabled = true;
            actions.find((act) => act.value == 13).disabled = true;
          }
        }

        break;

      case UserRolesInt.JobOperator:
        break;

      case UserRolesInt.Reader:
        actions.forEach((act) => (act.disabled = true));
        return actions;

      default:
        actions.forEach((act) => (act.disabled = true));
        if (node.nodeType == NodeTypes.TxtWorkstation) {
          if (!node.isAllowedToConnect)
            actions.find((act) => act.value == 3).disabled = true;
        }
        break;
    }

    if (
      node.nodeType == NodeTypes.TxtWorkstation &&
      currentUserRole != UserRolesInt.JobOperator
    ) {
      let deploymentName = this.route.parent.snapshot.params["deploymentName"];
      if (deploymentName == "All") {
        if (node.state == HpcVMStates.STATE_CODE_UNASSIGNED) {
          actions.forEach((act) => {
            if (![5].includes(act.value)) {
              act.disabled = true;
            } else {
              act.disabled = false;
            }
          });
          actions.find((act) => act.value == 11).disabled = false;
        } else {
          actions.find((act) => act.value == 5).disabled = false;
          if (currentUserRole == UserRolesInt.DeploymentAdmin) {
            actions.find((act) => act.value == 6).disabled = true;
          } else {
            if (node.cloudType != CloudTypes.KVM) {
              actions.find((act) => act.value == 6).disabled = false;
            }
          }
        }
      } else {
        if (currentUserRole == UserRolesInt.DeploymentAdmin) {
          actions.find((act) => act.value == 6).disabled = true;
        } else {
          if (node.cloudType != CloudTypes.KVM) {
            actions.find((act) => act.value == 6).disabled = false;
          }
        }
      }
      actions.find((act) => act.value == 8).disabled = false;
      actions.find((act) => act.value == 7).disabled = false;
    }

    if (node.nodeType != NodeTypes.TxtWorkstation) {
      if (node.state != HpcVMStates.STATE_CODE_STARTED && node.reserved) {
        actions.find((act) => act.value == 3).disabled = true;
      }
    }

    if (
      node.nodeType == NodeTypes.TxtWorkstation &&
      node.availability == ResourceAvailability.BUSY &&
      node.reserved
    ) {
      actions.find((act) => act.value == 3).disabled = true;
    }

    if (this.depName == "All") {
      actions.find((act) => act.value == 12).disabled = true;
      actions.find((act) => act.value == 13).disabled = true;
      if (node.nodeType == NodeTypes.TxtWorkstation) {
        actions.find((act) => act.value == 10).disabled = false;
      }
      if (node.state == HpcVMStates.STATE_CODE_UNASSIGNED) {
        actions.find((act) => act.value == 7).disabled = true;
      }
      actions.find((act) => act.value == 3).disabled = true;
    }

    if (this.isMonitor == true) {
      actions.find((act) => act.value == 1).disabled = true;
      actions.find((act) => act.value == 2).disabled = true;
      actions.find((act) => act.value == 3).disabled = true;
      actions.find((act) => act.value == 4).disabled = true;
      actions.find((act) => act.value == 5).disabled = true;
      actions.find((act) => act.value == 6).disabled = true;
      actions.find((act) => act.value == 9).disabled = true;
      actions.find((act) => act.value == 10).disabled = true;
      actions.find((act) => act.value == 11).disabled = true;
      actions.find((act) => act.value == 12).disabled = true;
      actions.find((act) => act.value == 13).disabled = true;
    }
    if (fromAllNodes) {
      actions.find((act) => act.value == 1).disabled = true;
      actions.find((act) => act.value == 2).disabled = true;
      actions.find((act) => act.value == 4).disabled = true;
      actions.find((act) => act.value == 6).disabled = true;
    }

    if (node.cloudType == CloudTypes.KVM) {
      actions.find((act) => act.value == 3).disabled = true;
    }

    return actions;
  }

  getTooltipForNodeName(node: Node) {
    this.tooltipHtml = null;
    this.tooltipHtml = `<p>Description : ${node.description || "NA"
      }</p><p>Processor : ${node.processor || "NA"}</p><p>GPU Name : ${node.gpuName || "NA"
      }</p><p>GPU Ram Size : ${node.gpuRamSize ? node.gpuRamSize + " GB" : "NA"
      }</p><p>Operating System : ${node.vmOs || "NA"}</p><p>IP Address : ${node.vmIp || "NA"
      }</p>`;
    return this.tooltipHtml;
  }

  loadAllNodesList() {
    this.nodeService
      .getAllNodesForUser()
      .pipe(
        map((nodes: any) => {
          nodes.forEach((n) => {
            n.actionsAvl = this.returnActionsAvailableForNodes(n, false);
          });
          return nodes;
        })
      )
      .subscribe({
        next: (data) => {
          this.nodes = JSON.parse(JSON.stringify(data));
          if (this.nodes) {
            if (data == null) {
              this.spinner.hide("allNodesList");
              this.snackBar.open("Nodes not found", "Ok");
              this.nodes = [];
              return;
            }
            if (!this.selectedNode) {
              this.selectedNode = this.nodes[0];
              this.redirectTo(this.nodes[0], 0);
            }
            this.available = true;
            this.selectedIndex = this.nodes.findIndex(
              (node) =>
                node.vmName == this.selectedNode.vmName &&
                node.depName == this.selectedNode.depName
            );
            this.nodeService.updateSelectedNode(this.nodes[this.selectedIndex]);

            this.avlDeploymentsForFilter = [
              ...new Set(this.nodes.map((nd) => nd.depName)),
            ];
            this.navService.sendLastUpdate(
              this._headerService.getUserNewDate()
            );
          }

          this.spinner.hide("allNodesList");
        },
        error: (err) => {
          this.available = false;
          this.spinner.hide("allNodesList");
          this.snackBar.open("Nodes not found", "Ok");
          this.nodes = [];
        },
      });
  }

  applyFilter() {
    this.filtersApplied = true;
    //this.dataReloadSubscription?.unsubscribe();
    this.filteredNodes = this.nodes;
    if (this.nodesSearchText != "") {
      this.filteredNodes = this.filteredNodes.filter((nd) =>
        nd.vmName.toLowerCase().includes(this.nodesSearchText.toLowerCase())
      );
    }
    if (this.filterAvailability != "All") {
      if (this.filterAvailability.toLowerCase() == "na") {
        this.filteredNodes = this.filteredNodes.filter(
          (nd) =>
            nd.availability == this.filterAvailability ||
            nd.availability == null
        );
      } else {
        this.filteredNodes = this.filteredNodes.filter(
          (nd) => nd.availability == this.filterAvailability
        );
      }
    }
    if (this.filterNodetypes != "All") {
      this.filteredNodes = this.filteredNodes.filter((nd) => {
        return nd.nodeType
          .toLowerCase()
          .includes(this.filterNodetypes.toLowerCase());
      });
    }
    if (this.filterState != "All") {
      if (this.filterState == HpcVMStates.STATE_CODE_STOPING_CANCEL_WAIT) {
        this.filteredNodes = this.filteredNodes.filter(
          (nd) =>
            nd.state == HpcVMStates.STATE_CODE_STOPING ||
            nd.state == HpcVMStates.STATE_CODE_STOPING_CANCEL_WAIT
        );
      } else {
        this.filteredNodes = this.filteredNodes.filter(
          (nd) => !nd.state.localeCompare(this.filterState)
        );
      }
    }
    if (this.filterPlatform != "All") {
      this.filteredNodes = this.filteredNodes.filter(
        (nd) => nd.vmPlatform.toLowerCase() == this.filterPlatform.toLowerCase()
      );
    }
    return this.filteredNodes;
  }

  resetFilter() {
    this.resetSortFilter();
    //this.dataReloadSubscription?.unsubscribe()
    this.filtersApplied = false;
    this.filterDeployment = this.depName;
    this.filterNodetypes = "All";
    this.filterAvailability = "All";
    this.filterState = "All";
    this.filterPlatform = "All";
    this.filtersApplied = false;
    this.nodesSearchText = "";
    this.loadNodeData();
    this.startDataReloadSub();
  }

  sortCPU(toggle) {
    if (toggle) {
      this.cpuSort = !this.cpuSort;
    }
    this.activeSort = "cpuUsage";
    this.ramSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;
    this.availabilitySort = false
    //this.filtersApplied = true;
    if (this.cpuSort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.cpuUsage < a.cpuUsage ? 1 : -1)
      );
    }
  }
  sortCores(toggle) {
    if (toggle) {
      this.coresSort = !this.coresSort;
    }
    this.activeSort = "cores";
    this.cpuSort = false;
    this.ramSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;
    this.availabilitySort = false;
    if (this.coresSort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.cores < a.cores ? 1 : -1)
      );
    }
  }
  sortRAM(toggle) {
    if (toggle) {
      this.ramSort = !this.ramSort;
    }
    this.activeSort = "ramUsage";
    this.cpuSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;
    this.availabilitySort = false;
    if (this.ramSort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.ramUsage < a.ramUsage ? 1 : -1)
      );
    }
  }

  sortGPU(toggle) {
    if (toggle) {
      this.gpuSort = !this.gpuSort;
    }
    this.activeSort = "gpuUsage";
    this.cpuSort = false;
    this.ramSort = false;
    this.gpuMemorySort = false;
    this.availabilitySort = false;
    if (this.gpuSort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.gpuUsage < a.gpuUsage ? 1 : -1)
      );
    }
  }

  sortGPUMemory(toggle) {
    if (toggle) {
      this.gpuMemorySort = !this.gpuMemorySort;
    }
    this.activeSort = "gpuMemoryUsage";
    this.cpuSort = false;
    this.ramSort = false;
    this.availabilitySort = false;
    this.gpuSort = false;
    if (this.gpuMemorySort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.gpuMemoryUsage < a.gpuMemoryUsage ? 1 : -1)
      );
    }
  }

  sortLoadData() {
    if (this.cpuSort) {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.cpuUsage > a.cpuUsage ? 1 : -1)
      );
    }
    if (this.ramSort) {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.ramUsage > a.ramUsage ? 1 : -1)
      );
    }
    if (this.gpuSort) {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.gpuUsage > a.gpuUsage ? 1 : -1)
      );
    }
    if (this.gpuMemorySort) {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.gpuMemoryUsage > a.gpuMemoryUsage ? 1 : -1)
      );
    }
    if (this.coresSort) {
      this.nodes = this.nodes.sort(
        (a, b) => 0 - (b.cores > a.cores ? 1 : -1)
      );
    }
  }

  resetSortFilter() {
    this.cpuSort = false;
    this.ramSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;
    this.filterDeployment = this.depName;
    this.filterNodetypes = "All";
    this.filterState = "All";
    this.filterPlatform = "All";
  }

  startDataReloadSub() {
    if (this.dataReloadSubscription?.closed == false) return;
    this.dataReloadSubscription = interval(
      this.syncConfig.config.node.listReqInterval
    ).subscribe(async () => {
      await this.loadNodeDataOnReloadSubscription();
      await this.getScaleData();
      this.navService.sendLastUpdate(this._headerService.getUserNewDate());
    });
  }

  connectVdiNode() {
    const dialogRef = this.dialog.open(DynamicWorkstationComponent, {
      width: "25vw",
      autoFocus: false,
      disableClose: true,
      data: {
        deploymentNames: [this.depName],
        gpuNames: [
          ...new Set(
            this.nodes
              .filter((nd) => nd.nodeType == NodeTypes.TxtWorkstation)
              .map((nd) => nd.gpuName)
          ),
        ],
        availableRam: [
          ...new Set(
            this.nodes
              .filter((nd) => nd.nodeType == NodeTypes.TxtWorkstation)
              .map((nd) => nd.totalRam)
          ),
        ],
        availableCores: [
          ...new Set(
            this.nodes
              .filter((nd) => nd.nodeType == NodeTypes.TxtWorkstation)
              .map((nd) => nd.cores)
          ),
        ],
      },
    });
  }

  getNetworkInfo() {
    this.nodeService.getNodeNetworkInfo(this.selectedNode.vmName).subscribe({
      next: (data) => {
        this.nodeNetwork = JSON.parse(JSON.stringify(data));
      },
      error: (err) => { },
    });
  }

  performAction(action: NodeAction, node: Node) {
    this.spinner.show("nodeList");
    const dialogRef = this.dialog.open(NodeactionConfirmComponent, {
      disableClose: true,
      width: "450px",
      data: {
        node: node.vmName,
        nodeType: node.nodeType,
        deployment: node.depName,
        actionName: action.name,
        actionVal: action.value,
        message: this.message,
        platform: node.vmPlatform, // windows linux
        showWarning: this.headAndComputeNodeActive,
        forcefully: this.forcefully,
      },
    });
    dialogRef.afterOpened().subscribe(() => {
      this.spinner.hide("nodeList");
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.headAndComputeNodeActive = false;
      if (res) {
        setTimeout(() => {
          if (this.nodeDataRequestSub) this.nodeDataRequestSub.unsubscribe();
          if (this.depName == "All") {
            this.loadAllNodesList();
            return;
          }
          this.loadNodeData();
        }, 1000);
        this.refreshComponent();
      }
    });
  }

  removeSession(node: Node) {
    this.openRemoveSessionDialog(node.vmName);
    if (node?.sessions?.length == 0) {
      this.snackBar.open(
        `No session is active on node ${node.vmName} to remove.`,
        "Ok",
        { duration: 5000 }
      );
      return;
    }
    this.dialog
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        disableClose: false,
        width: "25%",
        data: {
          titleMessage: "Remove Session",
          bodyMessage: `Do you want to remove ${node.sessions[0]} from ${node.vmName}`,
          cancelText: "Cancel",
          submitText: "Proceed",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open("Action is in progress.", "Ok", {
            duration: 5000,
          });
          this.sessionService
            .removeSession(
              node.vmName,
              node.sessions[0],
              node.depName,
              this.loggedInUser
            )
            .subscribe({
              next: (data: any) => {
                this.snackBar.open(data?.actionMessage, "Ok", {
                  duration: 5000,
                });
                //this.loadSessionData();
              },
              error: (err) => {
                this.snackBar.open(err.error?.actionMessage, "Ok", {
                  duration: 5000,
                });
              },
            });
        }
      });
  }
  sortAvailability(toggle) {
    if (toggle) {
      this.availabilitySort = !this.availabilitySort;
    }
    this.activeSort = "availability";

    // Reset other sorts
    this.cpuSort = false;
    this.ramSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;

    if (this.availabilitySort) {
      // Ascending - alphabetical order (A to Z)
      this.nodes = this.nodes.sort((a, b) => {
        const aVal = a.availability ? a.availability : "NA";
        const bVal = b.availability ? b.availability : "NA";
        return aVal.localeCompare(bVal);
      });
    } else {
      // Descending - reverse alphabetical order (Z to A)
      this.nodes = this.nodes.sort((a, b) => {
        const aVal = a.availability ? a.availability : "NA";
        const bVal = b.availability ? b.availability : "NA";
        return bVal.localeCompare(aVal);
      });
    }
  }
  refreshComponent() {
    let url = this.router.url;
    this.jobService.updateJobAction(null);
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  loadNodeDataOnReloadSubscription() {
    this.nodeDataRequestSub = this.nodeService
      .getNodesForDeployment(this.depName)
      .pipe(
        map((nodes: any) => {
          if (nodes) {
            nodes?.forEach((n) => {
              n.actionsAvl = this.returnActionsAvailableForNodes(n, false);
            });
            return nodes;
          }
        })
      )
      .subscribe((data) => {
        if (data) {
          this.nodes = JSON.parse(JSON.stringify(data));
          if (this.nodes) {
            this.available = true;
            if (this.activeSort != null || this.activeSort != "None") {
              this.applySort(this.activeSort, false);
            }
          } else {
            this.available = false;
          }
          this.spinner.hide("nodeList");
        } else {
          this.available = false;
          this.spinner.hide("nodeList");
        }
      });
  }

  getColumnSetting() {
    this.userServices.getColumnSetting(this.loggedInUser).subscribe((res) => {
      if (res) {
        let s = JSON.parse(JSON.stringify(res));
        if (s.data != null) {
          let colInfo: UserSetting = <UserSetting>(
            JSON.parse(JSON.stringify(s.data))
          );
          const exists = colInfo?.columnSetting?.some(item => item?.tableName == this.tableName) || false;
          if (exists) {
            colInfo.columnSetting.forEach((e) => {
              if (e.tableName == this.tableName) {
                this.nodeListColumnToShow = e.columnInfo.split(",");
                this.columnInfo = {
                  ...this.columnInfo,
                  coloumToShow: [...this.nodeListColumnToShow],
                };
              }
            });
          }
          else {
            if (!this.isVdiDeployment && this.showBilling) {
              this.nodeListColumnToShow = [
                "Availability",
                "State",
                "Alloc/Total",
                "GPU Mem %",
                "GPU %",
                "Sessions",
                "HPC Units",
                "Billed Hrs",
                "SchedulerState",
                "Network (Mb/sec)",
                "Cores"
              ];
            } else {
              this.nodeListColumnToShow = [
                "Availability",
                "State",
                "Alloc/Total",
                "GPU Mem %",
                "GPU %",
                "Sessions",
                "SchedulerState",
                "Network (Mb/sec)",
                "Cores"
              ];
            }
          }
        } else {
          if (!this.isVdiDeployment && this.showBilling) {
            this.nodeListColumnToShow = [
              "Availability",
              "State",
              "Alloc/Total",
              "GPU Mem %",
              "GPU %",
              "Sessions",
              "HPC Units",
              "Billed Hrs",
              "SchedulerState",
              "Network (Mb/sec)",
              "Cores"
            ];
          } else {
            this.nodeListColumnToShow = [
              "Availability",
              "State",
              "Alloc/Total",
              "GPU Mem %",
              "GPU %",
              "Sessions",
              "SchedulerState",
              "Network (Mb/sec)",
              "Cores"
            ];
          }
        }
      } else {
        if (!this.isVdiDeployment && this.showBilling) {
          this.nodeListColumnToShow = [
            "Availability",
            "State",
            "Alloc/Total",
            "GPU Mem %",
            "GPU %",
            "Sessions",
            "HPC Units",
            "Billed Hrs",
            "SchedulerState",
            "Network (Mb/sec)",
            "Cores"
          ];
        } else {
          this.nodeListColumnToShow = [
            "Availability",
            "State",
            "Alloc/Total",
            "GPU Mem %",
            "GPU %",
            "Sessions",
            "SchedulerState",
            "Network (Mb/sec)",
            "Cores"
          ];
        }
      }
    });
  }

  editColoum() {
    if (!this.isVdiDeployment && this.showBilling) {
      this.columnInfo.columnsOfComponents = [
        "Availability",
        "State",
        "SchedulerState",
        "Node Group",
        "Alloc/Total",
        "GPU Mem %",
        "GPU %",
        "Sessions",
        "HPC Units",
        "Billed Hrs",
        "Network (Mb/sec)",
        "Cores"
      ];
    } else {
      this.columnInfo.columnsOfComponents = [
        "Availability",
        "State",
        "SchedulerState",
        "Node Group",
        "Alloc/Total",
        "GPU Mem %",
        "GPU %",
        "Sessions",
        "Network (Mb/sec)",
        "Cores"
      ];
    }
    const editColumnDailog = this.dialog.open(EditColoumsComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      data: {
        columnsFromComponents: [...this.columnInfo.columnsOfComponents],
        previoslySelectedColumns: [...this.columnInfo.coloumToShow],
      },
    });
    editColumnDailog.afterClosed().subscribe((res) => {
      if (res.status) {
        if (res.data != null && res.data.length >= 0) {
          let columsName = res.data.map((el) => el.name);
          let columsNameString = columsName.join(",");
          this.userServices
            .updateUserColumnSetting(
              this.loggedInUser,
              columsNameString,
              this.tableName
            )
            .subscribe((data) => {
              if (data) {
                let response = JSON.parse(JSON.stringify(data));
                if (response.status == 200) {
                  this.nodeListColumnToShow = columsNameString.split(",");
                  this.columnInfo = {
                    ...this.columnInfo,
                    coloumToShow: [...this.nodeListColumnToShow],
                  };
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                } else if (response.status != 200) {
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                }
              }
            });
        }
      }
    });
  }

  applySort(sort, toggle: boolean) {
    switch (sort) {
      case "ramUsage":
        this.sortRAM(toggle);
        break;
      case "cpuUsage":
        this.sortCPU(toggle);
        break;
      case "gpuUsage":
        this.sortGPU(toggle);
        break;
      case "gpuMemoryUsage":
        this.sortGPUMemory(toggle);
        break;
      default:
        break;
    }
  }

  showRescaleSlider() {
    if (
      ![CloudTypes.OnPremise.valueOf(), CloudTypes.KVM.valueOf()].includes(
        this.cloudType
      ) &&
      !this.autoRescaleFlag &&
      this.isNotJobOperator &&
      this.available &&
      !this.isVdiDeployment &&
      !this.isMonitor
    ) {
      return true;
    }
    return false;
  }

  toggleFilters() {
    this.toShowFilter = !this.toShowFilter;
  }

  openAddNodeWithTemplateDialog() {
    let userRole = this._headerService.getUserRoleForDeployment(this.depName);
    if (userRole == 3) {
      this.snackBar.open(
        "You are not authorized to perform this action",
        "Ok",
        {
          duration: 5000,
        }
      );
      return;
    }
    const dialogRef = this.dialog.open(AddNodeFromTemplateComponent, {
      width: "35vw",
      disableClose: true,
      autoFocus: false,
      data: {
        depName: this.depName,
        cloudType: this.cloudType,
        nodeList: this.nodes,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loadNodeData();
        this.refreshComponent();
      }
    });
  }

  toggleNodeView(node) {
    if (this.selectedNode.vmName == node.vmName && this.detailsViewOpen) {
      this.detailsViewOpen = false;
      return;
    }
    this.nodeService.activeNode = node;
    // this.router.navigate([node.vmName, "Details"], { relativeTo: this.route });
    this.nodeService.updateSelectedNode(node);
    this.toShowFilter = false;
    this.detailsViewOpen = true;
  }

  getDataOfNodeGroup(node: Node) {
    return node.azureServiceName?.split(",");
  }

  syncKvmVms() {
    const dialogRef = this.dialog.open(SyncNodesComponent, {
      width: "450px",
      disableClose: true,
      autoFocus: false,
      data: {
        depName: this.depName,
        nodeGroups: this.deploymentDetails?.nodeGroup,
      },
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loadNodeData();
        this.refreshComponent();
      }
    });
  }

  getActiveFiltersCount(): number {
    let count = 0;

    if (this.filterAvailability !== "All") count++;
    if (this.filterNodetypes !== "All") count++;
    if (this.filterState !== "All") count++;
    if (this.filterPlatform !== "All") count++;

    return count;
  }
}
